// extracted by mini-css-extract-plugin
export default {"error-panel":"form-error-panel_error-panel__8v1R9","error-icon":"form-error-panel_error-icon__iCrQ0","error-text":"form-error-panel_error-text__SLG+m"};